import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { SeleccionarVendedorComponent } from './seleccionar-vendedor/seleccionar-vendedor.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { IPTService } from 'src/app/services/ipt.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { RubroService } from 'src/app/services/rubro.service';

@Component({
  selector: 'app-cobertura-ipt',
  templateUrl: './cobertura-ipt.component.html',
  styleUrls: ['./cobertura-ipt.component.scss'],
  providers: [SecurityService],
})
export class CoberturaIPTComponent implements OnInit {
  // Modales
  @ViewChild(SeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: SeleccionarVendedorComponent;

  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = '_RB_TIPO_VISTA_RESUMEN_';
  readonly RB_TIPO_VISTA_DETALLE: String = '_RB_TIPO_VISTA_DETALLE_';

  // Form
  formHeader: FormGroup;
  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  vendedoresSeleccionados: Array<any> = [];
  optionsRubro: Array<any> = [];

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  vendedorSeleccionado: any = null;
  vendedoresSeleccionadosFormatted: String = null;
  rutVendedor: any;
  CodeVendedorSend: any;
  TIPO_VISTA: boolean = false;
  activateCliente: boolean = false;

  //DECLARACION VARIABLE DETALLE/RESUMEN PARA BUSCAR IPT
  DetalleIPTAll: Array<any> = null;
  DetalleListIPT: Array<any> = null;
  ResumenlistaIPTAll: Array<any> = null;
  listaIPTResumen: Array<any> = null;

  //CANTIDADES
  cantidadClientes: number = 0;
  cantidadClientesPedido: number = 0;
  TotalVenta: number = 0;
  totalPedidos: number = 0;
  totalCoberturaCliente: string = '0';
  totalCoberturaPedido: string = '0';

  cantidadClientesResumen: number = 0;
  cantidadClientesPedidoResumen: number = 0;
  totalPedidosResumen: number = 0;
  TotalVentaResumen: number = 0;

  private resumen_currentPayload: any = null;
  resumen_loading: boolean = false;
  resumen_listaMovimientos: Array<any> = null;
  resumen_listaMovimientosAll: Array<any> = null;
  resumen_paginationContext: PaginationContext = new PaginationContext();
  resumen_totales: any = null;

  private detalle_currentPayload: any = null;
  detalle_loading: boolean = false;
  detalle_listaMovimientos: Array<any> = null;
  detalle_listaMovimientosAll: Array<any> = null;
  detalle_paginationContext: PaginationContext = new PaginationContext();
  detalle_totales: any = null;

  // Utils
  private log: any;

  //dias de la semana ipt
  data = [
    { id: 0, label: 'Lunes', checked: false },
    { id: 1, label: 'Martes', checked: false },
    { id: 2, label: 'Miércoles', checked: false },
    { id: 3, label: 'Jueves', checked: false },
    { id: 4, label: 'Viernes', checked: false },
    { id: 5, label: 'Sábado', checked: false },
    { id: 6, label: 'Domingo', checked: false },
    { id: 7, label: 'Todos', checked: false },
  ];

  checkTodos: boolean = false;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private messageRendererService: MessageRendererService,
    private iptServise: IPTService,
    private toastService: ToastService,
    private rutService: RutService,
    private rubroService: RubroService
  ) {
    this.log = this.clog.log('REP. COBERTURA IPT.');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10;
    this.detalle_paginationContext.RecordsByPage = 10;
    this.loadMonths();
    this.loadYears();
    this.loadRubros();
    this.createForm();
    this.setDefaults();
  }

  onChange(event, index, item) {
    item.checked = !item.checked;
    if (item.checked === true) {
      this.data.forEach((x) => {
        if (x.id === item.id && item.checked) {
          x.checked = true;
        }
      });
    }

    //* SELECCIONAR TODOS LOS DIAS CUANDO EL ID ES 7, CORRESPONDIENTE A  */
    if (item.checked === true && item.id === 7) {
      this.checkTodos = true;
      this.data.forEach((x) => (x.checked = true));
    }

    if (item.checked === false && item.id === 7) {
      this.checkTodos = false;
      this.data.forEach((x) => (x.checked = false));
    }
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaRubro'), this.optionsRubro);
    });
  }

  //OBTENER EL MES Y AÑO
  loadMonths() {
    this.optionsMonth = this.datesService.GetMonths();
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears(10);
  }

  setDefaults() {
    if (this.optionsMonth.length > 0) this.formHeader.get('mes').setValue(new Date().getMonth() + 1);
    if (this.optionsYear.length > 0) this.formHeader.get('anho').setValue(this.optionsYear[0].value);
  }

  //OBTENER EL MES Y AÑO

  private createForm() {
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      mes: [null],
      anho: [null],
      ActivarCliente: [false, [Validators.required]],
      producto_sin_sku: [true],
      listaRubro: [[]],
    });
  }

  /********* MODAL VENDEDOR *********/
  openModalSeleccionarVendedor() {
    const vista = this.formHeader.get('tipoVista').value;
    if (vista === this.RB_TIPO_VISTA_RESUMEN) {
      this.TIPO_VISTA = true;
    } else {
      this.TIPO_VISTA = true;
    }

    this.modalSeleccionarVendedor.show();
  }

  onVendedorSeleccionado({ data }) {
    this.limpiarDataSeleccionada();
    this.vendedorSeleccionado = data;
  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null;
    this.clearData();
  }

  onVendedorSeleccionadoMultiple({ data, origen }) {
    this.log(origen, data);
    this.limpiarDataSeleccionada();
    // this.clienteSeleccionado = data
    this.vendedoresSeleccionados = data;
    this.vendedoresSeleccionadosFormatted = this.vendedoresSeleccionados.map((p) => p.nombre).join(', ');
  }

  /********* MODAL VENDEDOR *********/

  /* LIMPIAR FILTRO SI NO SE ENCUENTRA VENDEDOR */
  clearData() {
    this.vendedorSeleccionado = null;
    this.vendedoresSeleccionados = [];
  }

  limpiarDataSeleccionada() {
    this.vendedoresSeleccionados = [];
    this.vendedorSeleccionado = null;
  }
  /* FIN  LIMPIAR FILTRO SI NO SE ENCUENTRA VENDEDOR */

  /* LIMPIAR BUSQUEDA* */
  limpiarfiltros() {
    this.formHeader.reset();
    this.modalSeleccionarVendedor.cleanResultData();
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_RESUMEN);
    this.formHeader.get('producto_sin_sku').setValue(true);
    this.formHeader.get('ActivarCliente').setValue(false);

    this.setDefaults(); //OBTENER MES Y AÑO ACTUAL;
    this.clearData(); //LIMPIAR VARIABLE DE VENDEDOR/ES;
    this.data.map((x) => {
      x.checked = false;
    });
    this.DetalleListIPT = [];
    this.listaIPTResumen = [];
    this.totalPedidos = 0;
    this.TotalVenta = 0;
    this.cantidadClientes = 0;
    this.cantidadClientesPedido = 0;
    this.totalCoberturaCliente = null;
    this.totalCoberturaPedido = null;

    this.cantidadClientesResumen = 0;
    this.cantidadClientesPedidoResumen = 0;
    this.totalPedidosResumen = 0;
    this.TotalVentaResumen = 0;
  }

  onChangeCliente({ checked }) {
    this.activateCliente = checked;
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber);
    this.detalleBuscar(pageNumber);
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/

  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.resumen_paginationContext.CurrentPage = pageNumber;

    this.resumen_listaMovimientos = null;
    this.resumen_listaMovimientosAll = null;

    let vendedorCodigo: any = [];

    if (this.vendedoresSeleccionados.length > 0) {
      vendedorCodigo = this.vendedoresSeleccionados.map((x) => x.codigo);
    } else {
      if (this.vendedorSeleccionado) {
        vendedorCodigo[0] = this.vendedorSeleccionado.codigo;
      } else {
        vendedorCodigo = [];
      }
    }

    const { producto_sin_sku, mes, anho } = this.formHeader.value;
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        incluirCliente: this.activateCliente,
        incluirProductoSinSku: producto_sin_sku,
        mes: mes,
        anno: anho,
        vendedorSel: vendedorCodigo,
        lunes: this.checkTodos == true ? false : Boolean(this.data[0].checked), //lunes
        martes: this.checkTodos == true ? false : Boolean(this.data[1].checked), //martes
        miercoles: this.checkTodos == true ? false : Boolean(this.data[2].checked), //miercoles
        jueves: this.checkTodos == true ? false : Boolean(this.data[3].checked), //jueves
        viernes: this.checkTodos == true ? false : Boolean(this.data[4].checked), //viernes
        sabado: this.checkTodos == true ? false : Boolean(this.data[5].checked), //sabado
        domingo: this.checkTodos == true ? false : Boolean(this.data[6].checked), //domingo
        listaRubro: this.formHeader.get('listaRubro').value,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.resumen_paginationContext.RecordsByPage
    };
    this.resumen_currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.resumen_loading = true;
    this.iptServise.obtenerCoberturaIPTResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.resumen_loading = false;

        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      if (registros.length === 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.resumen_loading = false;
        return;
      }
      this.resumen_listaMovimientosAll = registros;
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length; //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage); //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1;
      this.resumen_loading = false;

      this.showPageResumen(this.resumen_paginationContext.CurrentPage);
      this.calculateTotalesResumen();
    });
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber;
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage;
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage);
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      //cantidad de clientes
      cantidadClientesResumen: _.sumBy(this.resumen_listaMovimientosAll, 'total_cliente_vendedor'),
      //cantidad clientes con pedido
      cantidadClientesPedidoResumen: _.sumBy(this.resumen_listaMovimientosAll, 'clientesConPedidos'),
      //Total pedidos
      totalPedidosResumen: _.sumBy(this.resumen_listaMovimientosAll, 'numero_pedido'),
      //Total venta
      TotalVentaResumen: _.sumBy(this.resumen_listaMovimientosAll, 'total_neto'),
    };
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage);
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.iptServise.obtenerCoberturaIPTResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.messageRendererService.showInfoMessages(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }
  /********* RESUMEN *********/

  /********* DETALLE *********/
  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.detalle_paginationContext.CurrentPage = pageNumber;

    let vendedorCodigo: any = [];

    if (this.vendedoresSeleccionados.length > 0) {
      vendedorCodigo = this.vendedoresSeleccionados.map((x) => x.codigo);
    } else {
      if (this.vendedorSeleccionado) {
        vendedorCodigo[0] = this.vendedorSeleccionado.codigo;
      } else {
        vendedorCodigo = [];
      }
    }

    const { producto_sin_sku, mes, anho } = this.formHeader.value;
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        incluirCliente: this.activateCliente,
        incluirProductoSinSku: producto_sin_sku,
        mes: mes,
        anno: anho,
        vendedorSel: vendedorCodigo,
        lunes: this.checkTodos == true ? false : Boolean(this.data[0].checked), //lunes
        martes: this.checkTodos == true ? false : Boolean(this.data[1].checked), //martes
        miercoles: this.checkTodos == true ? false : Boolean(this.data[2].checked), //miercoles
        jueves: this.checkTodos == true ? false : Boolean(this.data[3].checked), //jueves
        viernes: this.checkTodos == true ? false : Boolean(this.data[4].checked), //viernes
        sabado: this.checkTodos == true ? false : Boolean(this.data[5].checked), //sabado
        domingo: this.checkTodos == true ? false : Boolean(this.data[6].checked), //domingo
        listaRubro: this.formHeader.get('listaRubro').value,
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.detalle_paginationContext.RecordsByPage
    };
    this.detalle_currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.detalle_loading = true;
    this.detalle_listaMovimientos = null;
    this.detalle_listaMovimientosAll = null;

    this.iptServise.obtenerCoberturaIPTDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.detalle_loading = false;
        return;
      }

      const { registros } = respuesta;
      if (registros.length === 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.detalle_loading = false;
        return;
      }
      this.detalle_listaMovimientosAll = registros;
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length; //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage); //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1;
      this.detalle_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage);
      this.calculateTotalesDetalles();
      this.detalle_loading = false;
    });
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber;
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage;
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage);
  }

  calculateTotalesDetalles() {
    this.detalle_totales = {
      //cantidad de clientes
      cantidadClientes: this.detallePedido(this.detalle_listaMovimientosAll).length,
      //cantidad clientes con pedido
      cantidadClientesPedido: this.contarRegistrosConNumeroPedido(this.detalle_listaMovimientosAll),
      // Total pedidos
      totalPedidos: _.sumBy(this.detalle_listaMovimientosAll, 'numero_pedido'),
      // Total venta
      TotalVenta: _.sumBy(this.detalle_listaMovimientosAll, 'total_neto'),
      //Total Cobertura Pedido
      totalCoberturaPedido: ((_.sumBy(this.detalle_listaMovimientosAll, 'numero_pedido') / this.detallePedido(this.detalle_listaMovimientosAll).length) * 100).toFixed(2),
      //Total Cobertura Cliente
      totalCoberturaCliente: ((this.contarRegistrosConNumeroPedido(this.detalle_listaMovimientosAll) / this.detallePedido(this.detalle_listaMovimientosAll).length) * 100).toFixed(2),
    };
  }
  contarRegistrosUnicos(registros: any) {
    const registrosUnicos = new Set(registros);
    return registrosUnicos.size;
  }

  contarRegistrosConNumeroPedido(clientes: any) {
    return clientes.filter((cliente) => cliente.numero_pedido !== 0).length;
  }
  detallePedido(registros: any) {
    return registros.map((x) => x.cliente_proveedor_rut);
  }

  detalleOnPageChange(context: PaginationContext) {
    this.showPageDetalle(context.RequestedPage);
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.iptServise.obtenerCoberturaIPTDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }
}
